import { Tag as AntTag } from 'antd';
import 'antd/es/tag/style/index.js';
import styled from 'styled-components';

export const Tag = styled(AntTag)``;
